module.exports = __webpack_public_path__ + "static/media/case4.2b58fbac.jpg";